<div class="information-container">
  <p class="dynamic-text tertiary" [ngClass]="font?.size" [innerHTML]="information | translate"></p>
</div>
